module.exports = __webpack_public_path__ + "img/27-800x800.411b68d4.jpg";